const ReviewStatus = {
    REVIEW_CREATED: "REVIEW_CREATED",
    IN_PROGRESS: "IN_PROGRESS",
    READY_FOR_CONSENSUS: "READY_FOR_CONSENSUS",
    CONSENSUS_IN_PROGRESS: "CONSENSUS_IN_PROGRESS",
    CLOSED: "CLOSED",
    DELETED: "DELETED"
};

export default ReviewStatus;